// NOTE: CSS is enqueued separately by WordPress (style.scss is its own Vite
// entry), so it is intentionally NOT imported here.

import { gsap } from 'gsap'

import { initGlobals } from './setup/globals'
import { initComponents } from './setup/components'
import { initScrollTrigger } from './setup/scroll-trigger'
import { initSwup } from './setup/swup'
import { initViewManager } from './setup/view-manager'
import { initPageReveal } from './setup/page-reveal'

// Opt-in smooth scroll (off by default). See src/js/README.md.
// import { initLenis } from './setup/lenis'
// import { initScrollSmoother } from './setup/scroll-smoother'

// -----------------------------------------------------------------------------
// Phase 1 — construct. No DOM queries here. Lines are in dependency order.
// -----------------------------------------------------------------------------
const ctx = initGlobals() // breakpoints, browser, eventBus; sets window.app
initComponents(ctx) // ctx.componentsManager (registers; mounts in Phase 2)
initScrollTrigger(ctx) // ctx.scrollTriggerManager
initSwup(ctx) // ctx.swup
initViewManager(ctx) // depends on ctx.componentsManager + ctx.swup
const { runPageReveal } = initPageReveal(ctx) // depends on ctx.swup
ctx.runPageReveal = runPageReveal

// -----------------------------------------------------------------------------
// Phase 2 — start. DOM-dependent work, run once after the DOM is ready.
// -----------------------------------------------------------------------------
const start = () => {
	ctx.componentsManager.init() // query + mount components
	ctx.viewManager.mount() // resolve root, bind listeners
	ctx.runPageReveal('direct')

	hidePageLoader()
}

const hidePageLoader = () => {
	const el = document.querySelector('.js-overlay-loader')
	if (!el) return

	gsap.fromTo(
		el,
		{ opacity: 1 },
		{
			opacity: 0,
			duration: 0.25,
			delay: 0.3,
			onComplete: () => gsap.set(el, { display: 'none' }),
		},
	)
}

document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, { once: true }) : start()

// import { revealOnLoad } from './core/page-reveal/reveal-controller.js'
// import { initGlobals } from './setup/globals'
// import { initComponents } from './setup/components'
// import { initScrollTrigger } from './setup/scroll-trigger'
// import { initSwup } from './setup/swup'
// import { initScrollSmoother } from './setup/scroll-smoother'
// import { initViewManager } from './setup/view-manager'
// import { initPageReveal } from './setup/page-reveal'
// import ThemeSections from './core/theme-sections.js'
// // import { ThemeManager } from './core/theme-context.js'
// import { initTheme } from './setup/theme'

// // 1. Bootstrap application
// const bootstrap = () => {
// 	const ctx = initGlobals()
// 	window.ctx = ctx

// 	// // setup theme manager and sections
// 	// // Initial context for the current page (before Swup has run once)
// 	// ThemeManager.registerContext({
// 	// 	id: 'page',
// 	// 	element: document.body,
// 	// 	// auto picks up body.getAttribute("data-theme")
// 	// })

// 	// // setup theme sections to detect the different themes in sections
// 	// const themeSections = new ThemeSections({ themeManager: ThemeManager })
// 	// ctx.themeSections = themeSections

// 	// // Initial context for the current page (before Swup has run once)
// 	// ThemeManager.registerContext({
// 	// 	id: 'page',
// 	// 	element: document.body,
// 	// 	// auto picks up body.getAttribute("data-theme")
// 	// })

// 	// // Initialize theme manager
// 	// ctx.themeSections = new ThemeSections({})

// 	//
// 	initComponents(ctx)
// 	initScrollTrigger(ctx)
// 	// initScrollSmoother(ctx);

// 	initTheme(ctx)

// 	// Setup SWUP
// 	initSwup(ctx)

// 	// Setup View Manager
// 	initViewManager(ctx)

// 	// Setup page reveal
// 	const { runPageReveal } = initPageReveal(ctx)
// 	ctx.runPageReveal = runPageReveal
// }

// // 2. Initialize application on DOM ready
// const initialize = () => {
// 	const { componentsManager } = window.app

// 	// The loader overlay is opaque on load. The controller mounts all components and
// 	// forces the ScrollTrigger reflow *behind* it, then plays the entrance + mask exit
// 	// once the app has settled (with a min-display floor and a ceiling fallback).
// 	revealOnLoad(componentsManager)
// }

// // Start
// bootstrap()

// document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initialize, { once: true }) : initialize()

// // src/js
// // ├── core/
// // │   ├── browser.js
// // │   ├── components-manager.js
// // │   └── view-manager/
// // │       ├── navigation-controller.js
// // │       └── ...
// // ├── setup/
// // │   ├── index.js              (boot sequence)
// // │   ├── lenis.js
// // │   ├── gsap.js
// // │   ├── swup.js
// // │   └── overlays.js
// // ├── components/
// // │   ├── dynamic-button/
// // │   ├── media/
// // │   └── navigation/
// // ├── modules/
// // │   ├── accordion/
// // │   ├── slider/
// // │   └── lightbox/
// // ├── utils/
// // │   ├── dom/
// // │   ├── animation/
// // │   └── network/
// // ├── legacy/
// // │   └── _old-components/
// // └── index.js
